'use strict';

var Util = require('../util/index');
var Event = require('../util/event');
var xhr = window.XMLHttpRequest;

module.exports = function interceptAjax() {
    var enableLogTrace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var project = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var catchAbort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var catchTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!xhr || xhr._owl) return;
    xhr._owl = true;

    if (window.location && window.location.protocol === 'file:') return;

    try {
        var _open = xhr.prototype.open;
        var _send = xhr.prototype.send;
        var origin = Util.getOrigin();

        xhr.prototype.open = function (method, url) {
            this._startTime = +new Date();
            this.method = method;
            this.url = url;
            _open && _open.apply(this, arguments);

            try {
                // setRequestHeader should be after xhr.open
                if (enableLogTrace && project && Util.checkSameOrigin(url, origin) && typeof this.setRequestHeader === 'function') {
                    var id = Util.traceid();
                    if (id) {
                        this.setRequestHeader('M-TRACEID', id);
                        this.setRequestHeader('M-APPKEY', 'fe_' + project);
                        this.traceid = id;
                    }
                }
            } catch (e) {
                Util.reportSysError(e);
            }
        };

        xhr.prototype.send = function () {
            var _this = this,
                _arguments = arguments;

            var EVENT_LISTENER = 'addEventListener';
            var STATE_CHANGE = 'onreadystatechange';
            var _dispatchEvent = function _dispatchEvent(event) {
                if (!event || !event.currentTarget) return;

                if (/catfront.(dianping|51ping).com/.test(_this.url)) {
                    try {
                        var response = void 0;
                        if (_this.getAllResponseHeaders('content-type').indexOf('application/json') !== -1) {
                            response = JSON.parse(event.currentTarget.response);
                        }
                        // callback of Owl report requests
                        if (event.currentTarget.status === 200) {
                            _this.success && _this.success(response);
                        } else {
                            _this.fail && _this.fail(response);
                        }
                    } catch (e) {}
                } else {
                    event.duration = +new Date() - _this._startTime;
                    Event.trigger('ajaxCall', event);
                }
            };

            if (EVENT_LISTENER in this) {
                this[EVENT_LISTENER]('load', _dispatchEvent);
                this[EVENT_LISTENER]('error', _dispatchEvent);
                catchAbort && this[EVENT_LISTENER]('abort', _dispatchEvent);
                catchTimeout && this[EVENT_LISTENER]('timeout', _dispatchEvent);
            } else {
                var _originStateChange = this[STATE_CHANGE];
                this[STATE_CHANGE] = function (event) {
                    if (_this.readyState === 4) {
                        _dispatchEvent(event);
                    }
                    _originStateChange && _originStateChange.apply(_this, _arguments);
                };
            }

            return _send && _send.apply(this, arguments);
        };
    } catch (e) {
        Util.reportSysError(e);
    }
};